import { DEFAULT_STORE_OBJECT } from '../../contants/common';
import { convertDateUTCToUserLocal } from '../../utilz/dates';
import VisibilityTypes from './VisibilityTypes';

const initialState = {
  supplierList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    progressing: true,
  },
  visibilitySearchList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    req: {
      shipmentType: 'O',
      customerKey: '',
      carrierKey: '',
      vendorKey: '',
      pageIndex: 1,
      pageSize: 20,
      statusCode: '',
      searchFlag: '',
    },
    progressing: false,
  },
  trackingStatusDetails: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  productInfo: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  getShipmentNotesetails: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  getShipperConsigneeDetails: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  transportationProviderList: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  updateShipmentTrackingDetailsData: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  exceptionData: {
    ...DEFAULT_STORE_OBJECT,
    progressing: false,
    data: [],
  },
  addnewfileactions: {
    ...DEFAULT_STORE_OBJECT,
    btnCliked: false,
  },
  footerContentData: {
    ...DEFAULT_STORE_OBJECT,
    btnCliked: false,
  },
  addNewStatusAction: {
    ...DEFAULT_STORE_OBJECT,
    btnCliked: false,
  },

  selectedVisibility: {
    data: {},
  },
  excelData: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  sendEmail: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  exportDetails: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  editGeneralBtnInfo: {
    isBtnClicked: false,
  },
  editDetailsBtnInfo: {
    isBtnClicked: false,
  },
  updateRedAndDockNoInfo: {
    ...DEFAULT_STORE_OBJECT,
    data: {},
  },
  updateShipmentNoteData: {
    ...DEFAULT_STORE_OBJECT,
    data: {},
  },
  supperlierData: {
    data: [],
    success: false,
    customerKey: '',
  },
  branchData: {
    data: [],
    success: false,
    customerKey: '',
  },
  transportationProviderListData: {
    companyId: '',
    userType: '',
  },
};

// biome-ignore lint/style/useDefaultParameterLast: can't be modified
const VisibilityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VisibilityTypes.BRANCH_DATA: {
      return {
        ...state,
        branchData: {
          data: payload.data,
          success: payload.success,
          customerKey: payload.customerKey,
        },
      };
    }

    case VisibilityTypes.SUPPLIER_TYPE_DATA: {
      return {
        ...state,
        supperlierData: {
          data: payload.data,
          success: payload.success,
          customerKey: payload.customerKey,
        },
      };
    }

    case VisibilityTypes.GET_SUPPLIER_TYPES: {
      return {
        ...state,
        supplierList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.supplierList,
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_SUPPLIER_TYPES_SUCCESS: {
      return {
        ...state,
        supplierList: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_SUPPLIER_TYPES_ERROR: {
      return {
        ...state,
        supplierList: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS: {
      return {
        ...state,
        visibilitySearchList: {
          ...state.visibilitySearchList,
          data: payload.data,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_SEARCH_LIST: {
      return {
        ...state,
        visibilitySearchList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.visibilitySearchList,
          req: {
            ...state.visibilitySearchList.req,
            ...payload,
          },
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_SUCCESS: {
      return {
        ...state,
        visibilitySearchList: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload.data,
          req: state.visibilitySearchList.req,
          data: [...state.visibilitySearchList.data, ...payload.data.totalData],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_FAIL: {
      return {
        ...state,
        visibilitySearchList: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          req: state.visibilitySearchList.req,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_CLEAR: {
      return {
        ...state,
        visibilitySearchList: {
          ...state.visibilitySearchList,
          data: [],
          footerData: [],
          req: {
            ...state.visibilitySearchList.req,
            shipmentType: 'O',
            customerKey: '',
            carrierKey: '',
            vendorKey: '',
            pageIndex: 1,
            pageSize: 20,
            statusCode: '',
            searchFlag: '',
          },
        },
      };
    }
    case VisibilityTypes.GET_VISIBILITY_SET_SEARCH_LIST_DATA: {
      return {
        ...state,
        visibilitySearchList: {
          ...state.visibilitySearchList,
          data: [],
          footerData: [],
          req: {
            ...state.visibilitySearchList.req,
            pageIndex: 1,
            pageSize: 20,
          },
        },
      };
    }

    case VisibilityTypes.GET_TRACKING_STATUS_DETAILS: {
      return {
        ...state,
        trackingStatusDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.trackingStatusDetails,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_TRACKING_STATUS_DETAILS_SUCCESS: {
      return {
        ...state,
        trackingStatusDetails: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload.data,
          data: payload.data.map((element) => ({
            ...element,
            dateTimeStamp: convertDateUTCToUserLocal(element.dateTimeStamp),
            eventOccurrence: convertDateUTCToUserLocal(element.eventOccurrence),
          })),
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_TRACKING_STATUS_DETAILS_FAIL: {
      return {
        ...state,
        trackingStatusDetails: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO: {
      return {
        ...state,
        productInfo: {
          ...DEFAULT_STORE_OBJECT,
          ...state.productInfo,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_SUCCESS: {
      return {
        ...state,
        productInfo: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload.data,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_FAIL: {
      return {
        ...state,
        productInfo: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS: {
      return {
        ...state,
        getShipmentNotesetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.getShipmentNotesetails,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS: {
      return {
        ...state,
        getShipmentNotesetails: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_FAIL: {
      return {
        ...state,
        getShipmentNotesetails: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS: {
      return {
        ...state,
        getShipperConsigneeDetails: {
          ...DEFAULT_STORE_OBJECT,
          ...state.getShipperConsigneeDetails,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS: {
      return {
        ...state,
        getShipperConsigneeDetails: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL: {
      return {
        ...state,
        getShipperConsigneeDetails: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.TRANSPORTATION_PROVIDER_DATA: {
      return {
        ...state,
        transportationProviderListData: {
          companyId: payload.CompanyId,
          userType: payload.userType,
        },
      };
    }

    case VisibilityTypes.GET_TRANSPORTATION_PROVIDER: {
      return {
        ...state,
        transportationProviderList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.transportationProviderList,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_TRANSPORTATION_PROVIDER_SUCCESS: {
      return {
        ...state,
        transportationProviderList: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_TRANSPORTATION_PROVIDER_FAIL: {
      return {
        ...state,
        transportationProviderList: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS: {
      return {
        ...state,
        updateShipmentTrackingDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          ...state.updateShipmentTrackingDetailsData,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS: {
      return {
        ...state,
        updateShipmentTrackingDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL: {
      return {
        ...state,
        updateShipmentTrackingDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR: {
      return {
        ...state,
        updateShipmentTrackingDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          ...state.updateShipmentTrackingDetailsData,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEPTION: {
      return {
        ...state,
        exceptionData: {
          ...DEFAULT_STORE_OBJECT,
          ...state.exceptionData,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEPTION_SUCCESS: {
      return {
        ...state,
        exceptionData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEPTION_FAIL: {
      return {
        ...state,
        exceptionData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEPTION_CLEAR: {
      return {
        ...state,
        exceptionData: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.ADD_NEW_FILE_ACTION: {
      return {
        ...state,
        addnewfileactions: {
          ...DEFAULT_STORE_OBJECT,
          btnCliked: payload,
        },
      };
    }

    case VisibilityTypes.ADD_NEW_TRACKING_STATUS_ACTION: {
      return {
        ...state,
        addNewStatusAction: {
          ...DEFAULT_STORE_OBJECT,
          btnCliked: payload,
        },
      };
    }

    case VisibilityTypes.GET_FOOTER_CONTENT: {
      return {
        ...state,
        footerContentData: {
          ...DEFAULT_STORE_OBJECT,
          ...state.footerContentData,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_FOOTER_CONTENT_SUCCESS: {
      return {
        ...state,
        footerContentData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_FOOTER_CONTENT_FAIL: {
      return {
        ...state,
        footerContentData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
          data: [],
          progressing: false,
        },
      };
    }

    case VisibilityTypes.SET_SELECTED_VISIBILITY: {
      return {
        ...state,
        selectedVisibility: {
          ...DEFAULT_STORE_OBJECT,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.CLEAR_SELECTED_VISIBILITY: {
      return {
        ...state,
        selectedVisibility: {
          ...DEFAULT_STORE_OBJECT,
          data: {},
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEL_DATA: {
      return {
        ...state,
        excelData: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_SUCCESS: {
      return {
        ...state,
        excelData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_FAIL: {
      return {
        ...state,
        excelData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.SENT_EMAIL_VISIBILITY: {
      return {
        ...state,
        sendEmail: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.SENT_EMAIL_VISIBILITY_SUCCESS: {
      return {
        ...state,
        sendEmail: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data?.totalData,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.SENT_EMAIL_VISIBILITY_FAIL: {
      return {
        ...state,
        sendEmail: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS: {
      return {
        ...state,
        exportDetails: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS_SUCCESS: {
      return {
        ...state,
        exportDetails: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS_FAIL: {
      return {
        ...state,
        exportDetails: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.EDIT_GENETRAL_BTN_ACTION: {
      return {
        ...state,
        editGeneralBtnInfo: {
          isBtnClicked: payload === undefined ? !state.editGeneralBtnInfo.isBtnClicked : payload,
        },
      };
    }

    case VisibilityTypes.EDIT_DETAILS_BTN_ACTION: {
      return {
        ...state,
        editDetailsBtnInfo: {
          isBtnClicked: payload === undefined ? !state.editDetailsBtnInfo.isBtnClicked : payload,
        },
      };
    }

    case VisibilityTypes.UPDATE_REF_AND_DOCK_NO: {
      return {
        ...state,
        updateRedAndDockNoInfo: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case VisibilityTypes.UPDATE_REF_AND_DOCK_NO_SUCCESS: {
      return {
        ...state,
        updateRedAndDockNoInfo: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_REF_AND_DOCK_NO_FAIL: {
      return {
        ...state,
        updateRedAndDockNoInfo: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_NOTE: {
      return {
        ...state,
        updateShipmentNoteData: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_NOTE_SUCCESS: {
      return {
        ...state,
        updateShipmentNoteData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_NOTE_FAIL: {
      return {
        ...state,
        updateShipmentNoteData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_DETAILS: {
      return {
        ...state,
        updateShipmentDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_DETAILS_SUCCESS: {
      return {
        ...state,
        updateShipmentDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload.data,
          progressing: false,
        },
      };
    }

    case VisibilityTypes.UPDATE_SHIPMENT_DETAILS_FAIL: {
      return {
        ...state,
        updateShipmentDetailsData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          data: payload,
          progressing: false,
        },
      };
    }

    default:
      return state;
  }
};

export default VisibilityReducer;
